import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const LibraryIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75 16.5H4.5C3.25736 16.5 2.25 15.4926 2.25 14.25V3.75C2.25 2.50736 3.25736 1.5 4.5 1.5H15.75V13.5C15.3358 13.5 15 13.8358 15 14.25C15 14.6642 15.3358 15 15.75 15V16.5ZM13.5 14.25C13.5 13.987 13.5451 13.7346 13.628 13.5H4.5C4.08579 13.5 3.75 13.8358 3.75 14.25C3.75 14.6642 4.08579 15 4.5 15H13.628C13.5451 14.7654 13.5 14.513 13.5 14.25ZM4.5 3H14.25V12H4.5C4.23702 12 3.98458 12.0451 3.75 12.128V3.75C3.75 3.33579 4.08579 3 4.5 3Z"
    />
  </SvgIcon>
);

export default LibraryIcon;
